define('components/course/models/section',[
    'components/course/collections/slides',
    'components/course/models/base',
    'components/course/radio-channel'
], function (Slides, Base, channel) {
    "use strict";

    var ModuleEvent = channel.Event.Module,
        SectionEvent = channel.Event.Section,
        SlideEvent = channel.Event.Slide;

    return Base.extend({
        "authoringJSONKey": function () {
            return _.extend(Base.prototype.authoringJSONKey.call(this), {
                "slides": null
            });
        },

        "saveStateJSONKey": function () {
            return _.extend(Base.prototype.saveStateJSONKey.call(this), {
                "isActive": null,
                "isComplete": null,
                "isUnlocked": null,
                "lastSlideIndex": null,
                "slides": null
            });
        },

        "childrenAttribute": "slides",

        "url": "./section.cfc",

        "complexRelations": function () {
            var complexRelations = Base.prototype.complexRelations.call(this);

            complexRelations = _.union(complexRelations, [
                {
                    "attr": "slides",
                    "Class": Slides
                }
            ]);

            return complexRelations;
        },

        "defaults": function () {
            return _.extend(Base.prototype.defaults.call(this), {
                "isActive": false,
                "isComplete": false,
                "isUnlocked": false,
                "lastSlideIndex": 0,
                "slides": null
            });
        },

        "initialize": function () {
            this.listenTo(this.get('slides'), 'change', this.onSlidesChange)
                .listenTo(this, 'change:slides', this.onActiveChange);

            this.onSlidesChange()
                .onActiveChange();
        },

        "getActiveSlide": function () {
            return this.get('slides').getActiveSlide();
        },

        "setActiveSlide": function (slideIndex) {
            var slides = this.get('slides'),
                activeSlide = slides.getActiveSlide(),
                activeSlideIndex = slides.getActiveSlideIndex();

            if (slideIndex === activeSlideIndex) {
                return this;
            }

            this.set('lastSlideIndex', slideIndex);

            if (activeSlide) {
                activeSlide.set('isActive', false);
            }

            activeSlide = slides.at(slideIndex);
            activeSlide.set('isActive', true);

            return this;
        },

        "getLastSlide": function () {
            return this.get('slides').at(this.get('lastSlideIndex'));
        },

        "gotoSlide": function (slideIndex, navDirection) {
            var slides = this.get('slides'),
                activeSlideIndex = slides.getActiveSlideIndex();

            if (slideIndex === activeSlideIndex) {
                return this;
            }

            channel.command(ModuleEvent.NAV_DIRECTION, navDirection);

            if (slideIndex < 0) {
                channel.command(SectionEvent.PREV);
                channel.trigger(SlideEvent.CHANGE);
                return this;
            }

            if (slideIndex === slides.length) {
                channel.command(SectionEvent.NEXT);
                channel.trigger(SlideEvent.CHANGE);
                return this;
            }

            this.setActiveSlide(slideIndex);

            channel.trigger(SlideEvent.CHANGE);

            return this;
        },

        "nextSlide": function () {
            var slideIndex = this.get('slides').getActiveSlideIndex() + 1;

            return this.gotoSlide(slideIndex, 1);
        },

        "prevSlide": function () {
            var slideIndex = this.get('slides').getActiveSlideIndex() - 1;

            return this.gotoSlide(slideIndex, -1);
        },

        "onSlidesChange": function () {
            var isComplete = this.get('slides').isComplete();
            this.set('isComplete', isComplete);
            return this;
        },

        "onActiveChange": function () {
            var isActive = this.get('isActive'),
                activeSlide = this.getActiveSlide(),
                lastSlideIndex = this.get('lastSlideIndex') || 0,
                slides = this.get('slides');

            if (isActive && !activeSlide && slides.length) {
                slides.at(lastSlideIndex).set('isActive', true);
            }

            /*
            if (activeSlide) {
                activeSlide.set('isActive', false);
            }

            if (isActive && slides.length) {
                slides.at(0).set('isActive', true);
            }*/

            return this;
        }
    });
});

